import { apiClient } from '../client';
import { Department } from '../../types/admin';

export const departmentsApi = {
  list: () => apiClient.get<{ data: Department[] }>('/api/admin/departments'),
  create: (input: { name: string; code?: string | null; parentDepartmentId?: number | null }) =>
    apiClient.post<{ data: { id: number } }>('/api/admin/departments', input),
  update: (id: number, input: { name: string; code?: string | null; parentDepartmentId?: number | null }) =>
    apiClient.put<{ data: { id: number } }>(`/api/admin/departments/${id}`, input),
  deactivate: (id: number) => apiClient.patch<{ data: { id: number; is_active: boolean } }>(`/api/admin/departments/${id}/deactivate`),
};
